module.exports = __webpack_public_path__ + "static/media/wireless-signal.a1f3ee18.png";